module.exports = __webpack_public_path__ + "img/img (6).83a2a2bc.jpg";